import { AccountLimitsRequest, AccountLimitsResponse } from 'vopay';
import { useState } from 'react';
import axios from 'axios';
import apiConfig from '@/services/api.config';

const { api } = apiConfig;

// Omits from each union member separately; a plain Omit collapses the VelocityScope union and drops Rails.
type DistributiveOmit<T, K extends PropertyKey> = T extends unknown ? Omit<T, K> : never;

export type AccountLimits = DistributiveOmit<AccountLimitsResponse, 'Success' | 'ErrorMessage'>;

export default function useFetchAccountLimits() {
  const source = axios.CancelToken.source();
  const [fetching, setFetching] = useState(false);
  const [accountLimits, setAccountLimits] = useState<AccountLimits | null>(null);

  async function fetchAccountLimits(req: AccountLimitsRequest) {
    try {
      setFetching(true);
      const res = await api.fetchAccountLimits(req, source);

      if (!res.Success) throw new Error(res.ErrorMessage);

      setAccountLimits(res);

      return res;
    } finally {
      setFetching(false);
    }
  }

  return {
    fetching,
    accountLimits,
    fetchAccountLimits,
  };
}
